/**
 * Parallax Sections JavaScript
 *
 * This file defines Parallax Sections
 * behavior.
 */

// import dependencies
import { aniScroll } from '../../extended-blocks/extended-ani/scripts/aniScroll';

// add animations to all but last item
document.querySelectorAll('.plxs__item')?.forEach((el, i) => {
	// skip first item so other things parallax under it
	if (i) {
		// add class that we'll attach parallax animation to
		el.classList.add('ani--plxs');
	}
});

// call it!
aniScroll('.ani--plxs', true);
